export const courses = [
    {
        id: 1,
        name: "Front-end Development - 12 Module Course",
        description: "Learn in-demand skills like HTML, Cascading Style Sheet (CSS), JavaScript, Bootstrap, Version Control Sytems, Responsive Design, UI/UX Design Principles, Front-end Frameworks, Debugging and Troubleshooting, etc.",
        startDate: "Oct 05 2026",
        price: 500000,
        discountedPrice: 50000,
        ready: true,
        imgURL: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y29kZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",
        snippets: {
            goal: "Acquire top-notch skills in front-end development",
            experience: "Beginner/Intermediate Level",
            duration: "3 Months",
            languages: ["English"],
            certificate: "Certificate of Completion",
        },
        skills: [
            "Gain the technical skills required to become a qualified front-end developer",
            "Understand the principles of responsive design",
            "Learn to use modern front-end frameworks and libraries",
            "Build and deploy real-world projects",
            "Collaborate with other developers using version control",
            "Understand web accessibility standards",
        ],
        modules: [
            {
                title: "Module 1: Introduction to Web Design",
                contents: [
                    "What is Web Design?",
                    "Basics of HTML and CSS",
                    "Introduction to Web Development Tools",
                    "Setting Up Your Development Environment",
                    "Understanding Web Hosting and Domains",
                ],
            },
            {
                title: "Module 2: Advanced CSS Techniques",
                contents: [
                    "CSS Flexbox and Grid",
                    "Responsive Design Principles",
                    "CSS Preprocessors (SASS/LESS)",
                    "Animations and Transitions",
                    "Best Practices for CSS Organization",
                ],
            },
            {
                title: "Module 3: JavaScript Fundamentals",
                contents: [
                    "JavaScript Syntax and Basics",
                    "DOM Manipulation",
                    "Event Handling",
                    "Asynchronous JavaScript (Promises, Async/Await)",
                    "Introduction to ES6+ Features",
                ],
            },
            {
                title: "Module 4: Front-end Frameworks",
                contents: [
                    "Introduction to React.js",
                    "Component-based Architecture",
                    "State and Props",
                    "Routing with React Router",
                    "Building a Simple React Application",
                ],
            },
            {
                title: "Module 5: Version Control with Git",
                contents: [
                    "Introduction to Git and GitHub",
                    "Basic Git Commands",
                    "Branching and Merging",
                    "Collaborating on Projects",
                    "Resolving Merge Conflicts",
                ],
            },
            {
                title: "Module 6: Web Accessibility",
                contents: [
                    "Understanding Web Accessibility",
                    "ARIA Roles and Attributes",
                    "Keyboard Navigation",
                    "Color Contrast and Readability",
                    "Testing for Accessibility",
                ],
            },
            {
                title: "Module 7: Project Deployment",
                contents: [
                    "Preparing Your Project for Deployment",
                    "Using Netlify and Vercel for Deployment",
                    "Setting Up Continuous Deployment",
                    "Domain Management",
                    "Monitoring and Analytics",
                ],
            },
            {
                title: "Module 8: Performance Optimization",
                contents: [
                    "Optimizing Images and Assets",
                    "Minification and Bundling",
                    "Lazy Loading Techniques",
                    "Using a Content Delivery Network (CDN)",
                    "Performance Testing Tools",
                ],
            },
            {
                title: "Module 9: Testing and Debugging",
                contents: [
                    "Introduction to Testing",
                    "Unit Testing with Jest",
                    "Debugging Techniques",
                    "Using Browser Developer Tools",
                    "End-to-End Testing with Cypress",
                ],
            },
            {
                title: "Module 10: Advanced JavaScript Concepts",
                contents: [
                    "Closures and Scope",
                    "Higher-Order Functions",
                    "Event Loop and Asynchronous Programming",
                    "Modules and Imports/Exports",
                    "Design Patterns in JavaScript",
                ],
            },
            {
                title: "Module 11: State Management",
                contents: [
                    "Introduction to State Management",
                    "Using Redux with React",
                    "Context API",
                    "Managing Side Effects with Thunks and Sagas",
                    "Best Practices for State Management",
                ],
            },
            {
                title: "Module 12: Final Project (Capstone)",
                contents: [
                    "Project Planning and Design",
                    "Building the Application",
                    "Testing and Debugging",
                    "Deployment",
                    "Project Presentation and Review",
                ],
            }
        ]
    },
    {
        id: 2,
        name: "Back-end Development - 10 Module Course",
        summary: "Master back-end development with this in-depth 10-module course covering server-side programming and databases.",
        description: "Master back-end development with this in-depth 10-module course covering server-side programming and databases.",
        startDate: "Oct 05 2026",
        price: 500000,
        discountedPrice: 50000,
        ready: true,
        imgURL: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YmFja2VuZCBkZXZlbG9wbWVudHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",
        snippets: {
            goal: "Learn the nitty gritties of Back-end development",
            experience: "Beginner/Intermediate Level",
            duration: "3 Months",
            languages: ["English"],
            certificate: "Certificate of Completion",
        },
        skills: [
            "Learn server-side programming languages",
            "Understand database management and SQL",
            "Build and deploy back-end applications",
            "Implement RESTful APIs",
            "Ensure application security and authentication",
            "Optimize server performance",
        ],
        modules: [
            {
                title: "Module 1: Introduction to Back-end Development",
                contents: [
                    "What is Back-end Development?",
                    "Overview of Server-side Languages",
                    "Setting Up a Local Server",
                    "Introduction to Databases",
                    "Understanding APIs",
                ],
            },
            {
                title: "Module 2: Node.js and Express.js",
                contents: [
                    "Introduction to Node.js",
                    "Setting Up an Express.js Server",
                    "Routing in Express.js",
                    "Middleware Functions",
                    "Building a Simple RESTful API",
                ],
            },
            {
                title: "Module 3: Database Management with MongoDB",
                contents: [
                    "Introduction to NoSQL Databases",
                    "Setting Up MongoDB",
                    "CRUD Operations",
                    "Data Modeling with Mongoose",
                    "Indexing and Aggregation",
                ],
            },
            {
                title: "Module 4: SQL Databases",
                contents: [
                    "Introduction to SQL",
                    "Setting Up MySQL/PostgreSQL",
                    "Writing SQL Queries",
                    "Joins and Relationships",
                    "Database Normalization",
                ],
            },
            {
                title: "Module 5: Authentication and Security",
                contents: [
                    "Understanding Authentication",
                    "Implementing JWT Authentication",
                    "Password Hashing",
                    "Securing APIs",
                    "Common Security Vulnerabilities",
                ],
            },
            {
                title: "Module 6: RESTful API Design",
                contents: [
                    "Principles of RESTful Design",
                    "Designing API Endpoints",
                    "Versioning APIs",
                    "Error Handling",
                    "Documenting APIs with Swagger",
                ],
            },
            {
                title: "Module 7: Testing and Debugging Back-end Applications",
                contents: [
                    "Introduction to Back-end Testing",
                    "Unit Testing with Mocha and Chai",
                    "Integration Testing",
                    "Debugging Techniques",
                    "Using Postman for API Testing",
                ],
            },
            {
                title: "Module 8: Deployment and Hosting",
                contents: [
                    "Preparing Your Back-end for Deployment",
                    "Using Heroku and AWS for Hosting",
                    "Setting Up Continuous Deployment",
                    "Environment Variables",
                    "Monitoring and Logging",
                ],
            },
            {
                title: "Module 9: Performance Optimization",
                contents: [
                    "Optimizing Database Queries",
                    "Caching Strategies",
                    "Load Balancing",
                    "Scaling Back-end Applications",
                    "Performance Monitoring Tools",
                ],
            },
            {
                title: "Module 10: Final Project (Capstone)",
                contents: [
                    "Project Planning and Design",
                    "Building the Back-end Application",
                    "Testing and Debugging",
                    "Deployment",
                    "Project Presentation and Review",
                ],
            }
        ]
    },
    {
        id: 3,
        name: "JavaScript Essentials - 8 Module Course",
        description: "Get up to speed with JavaScript through this essential 8-module course covering core concepts and practical applications.",
        startDate: "Oct 05 2026",
        price: 500000,
        discountedPrice: 50000,
        ready: true,
        imgURL: "/images/courses/js.jpg",
        snippets: {
            goal: "Become fluent in javascript",
            experience: "Beginner/Intermediate Level",
            duration: "3 Months",
            languages: ["English"],
            certificate: "Certificate of Completion",
        },
        skills: [
            "Understand core JavaScript concepts",
            "Write clean and efficient code",
            "Manipulate the DOM effectively",
            "Handle events and user interactions",
            "Work with APIs and asynchronous data",
            "Debug and test JavaScript applications",
        ],
        modules: [
            {
                title: "Module 1: JavaScript Basics",
                contents: [
                    "Introduction to JavaScript",
                    "Variables and Data Types",
                    "Operators and Expressions",
                    "Control Structures (if, switch, loops)",
                    "Functions and Scope",
                ],
            },
            {
                title: "Module 2: Working with the DOM",
                contents: [
                    "Understanding the Document Object Model (DOM)",
                    "Selecting and Manipulating DOM Elements",
                    "Creating and Removing Elements",
                    "Event Handling and Listeners",
                    "DOM Traversal",
                ],
            },
            {
                title: "Module 3: Arrays and Objects",
                contents: [
                    "Introduction to Arrays",
                    "Array Methods and Iteration",
                    "Introduction to Objects",
                    "Object Properties and Methods",
                    "Working with JSON",
                ],
            },
            {
                title: "Module 4: Asynchronous JavaScript",
                contents: [
                    "Understanding Asynchronous Programming",
                    "Callbacks and Promises",
                    "Async/Await Syntax",
                    "Fetching Data from APIs",
                    "Error Handling in Asynchronous Code",
                ],
            },
            {
                title: "Module 5: JavaScript ES6+ Features",
                contents: [
                    "Let and Const",
                    "Arrow Functions",
                    "Template Literals",
                    "Destructuring Assignment",
                    "Modules and Imports/Exports",
                ],
            },
            {
                title: "Module 6: Error Handling and Debugging",
                contents: [
                    "Common JavaScript Errors",
                    "Try...Catch Statements",
                    "Debugging Techniques",
                    "Using Browser Developer Tools",
                    "Best Practices for Error Handling",
                ],
            },
            {
                title: "Module 7: Testing JavaScript Code",
                contents: [
                    "Introduction to Testing",
                    "Unit Testing with Jest",
                    "Mocking Functions",
                    "Testing Asynchronous Code",
                    "Writing Effective Test Cases",
                ],
            },
            {
                title: "Module 8: Final Project",
                contents: [
                    "Project Planning and Design",
                    "Building a JavaScript Application",
                    "Testing and Debugging",
                    "Deployment",
                    "Project Presentation and Review",
                ],
            }
        ]
    },
    {
        id: 4,
        name: "Javascript Masterclass - 15 Module Course",
        description: "Become a JavaScript expert with this extensive 15-module masterclass covering everything from basics to advanced topics.",
        startDate: "Oct 05 2026",
        price: 500000,
        discountedPrice: 75000,
        ready: true,
        imgURL: "/images/courses/javascript.jpg",
        snippets: {
            goal: "Master Javascript",
            experience: "Intermediate Level",
            duration: "4 Months",
            languages: ["English"],
            certificate: "Certificate of Completion",
        },
        skills: [
            "Master JavaScript fundamentals and advanced concepts",
            "Develop complex web applications",
            "Utilize modern JavaScript frameworks",
            "Implement best practices in coding and design",
            "Optimize performance and security",
            "Collaborate effectively in development teams",
        ],
        modules: [
            {
                title: "Module 1: JavaScript Fundamentals",
                contents: [
                    "Introduction to JavaScript",
                    "Variables, Data Types, and Operators",
                    "Control Structures and Functions",
                    "Scope and Hoisting",
                    "Debugging Basics",
                ],
            },
            {
                title: "Module 2: Advanced JavaScript Concepts",
                contents: [
                    "Closures and Scope Chains",
                    "Higher-Order Functions",
                    "The 'this' Keyword",
                    "Prototypes and Inheritance",
                    "Event Loop and Asynchronous Programming",
                ],
            },
            {
                title: "Module 3: Working with the DOM",
                contents: [
                    "DOM Manipulation Techniques",
                    "Event Handling and Delegation",
                    "Creating and Modifying Elements",
                    "DOM Traversal Methods",
                    "Best Practices for DOM Interaction",
                ],
            },
            {
                title: "Module 4: JavaScript ES6+ Features",
                contents: [
                    "Let and Const Declarations",
                    "Arrow Functions and Template Literals",
                    "Destructuring and Spread/Rest Operators",
                    "Modules and Imports/Exports",
                    "Promises and Async/Await",
                ],
            },
            {
                title: "Module 5: Object-Oriented JavaScript",
                contents: [
                    "Object Creation Patterns",
                    "Constructor Functions and Classes",
                    "Inheritance and Prototypes",
                    "Encapsulation and Modules",
                    "Design Patterns in JavaScript",
                ],
            },
            {
                title: "Module 6: Functional Programming in JavaScript",
                contents: [
                    "First-Class Functions",
                    "Pure Functions and Immutability",
                    "Higher-Order Functions",
                    "Function Composition",
                    "Using Functional Programming Libraries",
                ],
            },
            {
                title: "Module 7: Working with APIs",
                contents: [
                    "Understanding RESTful APIs",
                    "Fetching Data with Fetch API and Axios",
                    "Handling JSON Data",
                    "Error Handling in API Calls",
                    "Integrating Third-Party APIs",
                ],
            },
            {
                title: "Module 8: Testing and Debugging",
                contents: [
                    "Debugging Techniques and Tools",
                    "Unit Testing with Jest",
                    "Mocking and Spying",
                    "Testing Asynchronous Code",
                    "Writing Effective Test Cases",
                ],
            },
            {
                title: "Module 9: Performance Optimization",
                contents: [
                    "Identifying Performance Bottlenecks",
                    "Optimizing Loops and Functions",
                    "Memory Management",
                    "Lazy Loading and Code Splitting",
                    "Using Performance Monitoring Tools",
                ],
            },
            {
                title: "Module 10: Security Best Practices",
                contents: [
                    "Common JavaScript Vulnerabilities",
                    "Cross-Site Scripting (XSS) Prevention",
                    "Secure Coding Practices",
                    "Using Content Security Policy (CSP)",
                    "Authentication and Authorization",
                ],
            },
            {
                title: "Module 11: Modern JavaScript Frameworks",
                contents: [
                    "Introduction to React.js",
                    "Component-Based Architecture",
                    "State and Props Management",
                    "Routing with React Router",
                    "Building a Simple React Application",
                ],
            },
            {
                title: "Module 12: Build Tools and Workflow",
                contents: [
                    "Introduction to Build Tools",
                    "Using Webpack and Babel",
                    "Task Runners (Gulp/Grunt)",
                    "Setting Up a Development Workflow",
                    "Version Control with Git",
                ],
            },
            {
                title: "Module 13: Deployment and Hosting",
                contents: [
                    "Preparing JavaScript Applications for Deployment",
                    "Using Netlify and Vercel for Hosting",
                    "Continuous Integration and Deployment",
                    "Domain Management",
                    "Monitoring and Analytics",
                ],
            },
            {
                title: "Module 14: Real-World Projects",
                contents: [
                    "Project Planning and Design",
                    "Building Complex JavaScript Applications",
                    "Testing and Debugging",
                    "Deployment",
                    "Project Presentation and Review",
                ],
            },
            {
                title: "Module 15: Career Development",
                contents: [
                    "Building a Strong Portfolio",
                    "Preparing for Technical Interviews",
                    "Networking in the Tech Industry",
                    "Continuing Education and Learning Resources",
                    "Staying Updated with JavaScript Trends",
                ],
            },
        ]
    },
    {
        id: 5,
        name: "Cybersecurity Advanced Concepts - 8 Module Course",
        description: "Advance your cybersecurity knowledge with this 8-module course covering in-depth concepts, tools, and techniques for protecting digital environments.",
        startDate: "Oct 05 2026",
        price: 500000,
        discountedPrice: 50000,
        ready: false,
        imgURL: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y29kZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",
        snippets: {
            goal: "8 Module Course",
            experience: "Beginner/Intermediate Level",
            duration: "4 Months Duration",
            languages: ["English"],
            certificate: "Certificate of Completion",
        },
        skills: [
            "Master advanced cybersecurity concepts",
            "Implement robust security measures",
            "Conduct thorough vulnerability assessments",
            "Respond effectively to complex security incidents",
            "Utilize cybersecurity tools and technologies",
            "Stay ahead of emerging cybersecurity threats",
        ],
        modules: [
            {
                title: "Module 1: Advanced Cybersecurity Concepts",
                contents: [
                    "In-Depth Cybersecurity Principles",
                    "Understanding Advanced Threats",
                    "Cybersecurity Architecture",
                    "Security Policies and Procedures",
                    "Cybersecurity Governance",
                ],
            },
            {
                title: "Module 2: Network Security",
                contents: [
                    "Network Protocols and Architecture",
                    "Implementing Firewalls and IDS/IPS",
                    "Virtual Private Networks (VPNs)",
                    "Network Segmentation",
                    "Securing Wireless Networks",
                ]
            },
            {
                title: "Module 3: Cryptography",
                contents: [
                    "Fundamentals of Cryptography",
                    "Symmetric vs Asymmetric Encryption",
                    "Hashing Algorithms",
                    "Digital Signatures and Certificates",
                    "Implementing Cryptographic Solutions",
                ],
            },
            {
                title: "Module 4: Vulnerability Assessment and Penetration Testing",
                contents: [
                    "Vulnerability Assessment Techniques",
                    "Penetration Testing Methodologies",
                    "Using Penetration Testing Tools",
                    "Reporting and Remediation",
                    "Ethical Hacking Principles",
                ],
            },
            {
                title: "Module 5: Security Information and Event Management (SIEM)",
                contents: [
                    "Introduction to SIEM",
                    "Log Management and Analysis",
                    "Setting Up a SIEM System",
                    "Real-Time Monitoring and Alerts",
                    "Incident Detection and Response",
                ],
            },
            {
                title: "Module 6: Advanced Incident Response",
                contents: [
                    "Complex Incident Response Strategies",
                    "Forensic Analysis Techniques",
                    "Malware Analysis",
                    "Coordinating Incident Response Teams",
                    "Post-Incident Reporting and Improvement",

                ]
            },
            {
                title: "Module 7: Cybersecurity Tools and Technologies",
                contents: [
                    "Overview of Cybersecurity Tools",
                    "Using SIEM Tools Effectively",
                    "Endpoint Security Solutions",
                    "Threat Intelligence Platforms",
                    "Automation in Cybersecurity",
                ],
            },
            {
                title: "Module 8: Emerging Trends and Future Directions",
                contents: [
                    "Current and Emerging Cybersecurity Trends",
                    "Impact of AI and Machine Learning on Cybersecurity",
                    "Cybersecurity in IoT",
                    "Preparing for Future Cyber Threats",
                    "Continuing Education and Professional Development",
                ],
            },
        ]
    },
    {
        id: 6,
        name: "Mobile App Development with React Native - 10 Module Course",
        description: "Learn to build mobile applications using React Native with this 10-module course covering essential concepts, tools, and techniques.",
        startDate: "Oct 05 2026",
        price: 500000,
        discountedPrice: 50000,
        ready: false,
        imgURL: "/images/courses/mobile.jpg",
        snippets: {
            goal: "10 Module Course",
            experience: "Beginner/Intermediate Level",
            duration: "3 Months Duration",
            languages: ["English"],
            certificate: "Certificate of Completion",
        },
        skills: [
            "Understand mobile app development fundamentals",
            "Build cross-platform mobile apps with React Native",
            "Implement navigation and state management",
            "Integrate APIs and handle data",
            "Test and deploy mobile applications",
            "Optimize app performance and user experience",
        ],
        modules: [
            {
                title: "Module 1: Introduction to Mobile App Development",
                contents: [
                    "Overview of Mobile App Development",
                    "Introduction to React Native",
                    "Setting Up the Development Environment",
                    "Understanding Cross-Platform Development",
                    "Creating Your First React Native App",
                ],
            },
            {
                title: "Module 2: React Native Fundamentals",
                contents: [
                    "React Native Components",
                    "JSX Syntax",
                    "Styling in React Native",
                    "Handling User Input",
                    "Working with Lists and ScrollViews",
                ],
            },
            {
                title: "Module 3: Navigation in React Native",
                contents: [
                    "Introduction to React Navigation",
                    "Stack Navigator",
                    "Tab Navigator",
                    "Drawer Navigator",
                    "Passing Data Between Screens",
                ],
            },
            {
                title: "Module 4: State Management",
                contents: [
                    "Understanding State and Props",
                    "Using the useState Hook",
                    "Context API for State Management",
                    "Introduction to Redux",
                    "Integrating Redux with React Native",
                ],
            },
            {
                title: "Module 5: Working with APIs and Data",
                contents: [
                    "Fetching Data from APIs",
                    "Using Axios for HTTP Requests",
                    "Handling JSON Data",
                    "Storing Data Locally with AsyncStorage",
                    "Implementing CRUD Operations",
                ],
            },
            {
                title: "Module 6: Testing React Native Apps",
                contents: [
                    "Introduction to Testing in React Native",
                    "Unit Testing with Jest",
                    "Component Testing with React Native Testing Library",
                    "End-to-End Testing with Detox",
                    "Debugging Techniques",
                ],
            },
            {
                title: "Module 7: Performance Optimization",
                contents: [
                    "Optimizing Render Performance",
                    "Using the FlatList Component",
                    "Memory Management",
                    "Profiling and Monitoring Performance",
                    "Best Practices for Performance",
                ],
            },
            {
                title: "Module 8: Deployment and Publishing",
                contents: [
                    "Preparing Apps for Deployment",
                    "Building for iOS and Android",
                    "Publishing to App Store and Google Play",
                    "App Store Optimization (ASO)",
                    "Post-Launch Maintenance",
                ],
            },
            {
                title: "Module 9: Advanced React Native Concepts",
                contents: [
                    "Using Native Modules",
                    "Animations in React Native",
                    "Geolocation and Maps",
                    "Push Notifications",
                    "Integrating Third-Party Libraries",
                ],
            },
            {
                title: "Module 10: Final Project (Capstone)",
                contents: [
                    "Project Planning and Design",
                    "Building a Complete React Native App",
                    "Testing and Debugging",
                    "Deployment and Publishing",
                    "Project Review and Feedback",
                ],
            }
        ]
    },

];

export const properties = [
    {
        title: "Seven Bedroom Duplex",
        desc: "Seven bedroom duplex, with two master bedrooms and two sitting rooms. It is equipped with electric fence, borehole, security gate house and it is optimally finished. It is newly built for luxury and comfort, and is located in the heart of town.",
        location: "Wuse, Zone 3, Abuja",
        price: 600000000,
        priceInWords: "Six Hundred Million Naira",
        status: "SOLD",
        imgURL: "/images/prop1/1.jpg"
    },
    {
        title: "FIVE BEDROOM DUPLEX WITH BQ",
        desc: "Five bedroom duplex with BQ, located within Efab Metropolitan, Gwarimpa, Abuja.",
        location: "Efab Metropolitan, Gwarimpa, Abuja",
        price: 50000000,
        priceInWords: "Fifty Million Naira",
        status: "SOLD",
        imgURL: "/images/prop2/1.jpg"
    }
]
